/**
 * Store sub context for admin data
 */
import { Filter } from '../../config/interfaces';

const AdminContext = {
  currentUsersPage: 1,
  adminUserTab: 'allUsers',
  adminUserFilter: {} as Filter,
  adminSearchTerm: '',
  selectedFacility: '',
  dataToCsvExport: [],
  dataToDownload: [],
  isLoadingCsvExport: false,
  isLoadingDownloadExport: false
};

export default AdminContext;
